import { GeoTransformer } from "../../helper/geo-helper";

export default interface ImagePositioning {
	center: [number, number];
	scale: number;
	rotation: number;
}

export const DEFAULT_IMAGE_POSITIONING: Readonly<ImagePositioning> = {
	center: [0, 0],
	scale: 1,
	rotation: 0,
};

export function imagePositioningToTransformer(
	state: ImagePositioning,
): GeoTransformer {
	return new GeoTransformer(state.scale, state.rotation, state.center);
}

export function imagePositioningToEdgeCoords(
	state: ImagePositioning,
	width: number,
	height: number,
): [[number, number], [number, number], [number, number], [number, number]] {
	const transformer = imagePositioningToTransformer(state);

	const halfX = width / 2;
	const halfY = height / 2;

	return [
		{ x: -halfX, y: halfY },
		{ x: halfX, y: halfY },
		{ x: halfX, y: -halfY },
		{ x: -halfX, y: -halfY },
	].map((it) => transformer.transform(it)) as [
		[number, number],
		[number, number],
		[number, number],
		[number, number],
	];
}
